import ko from "knockout";
import _ from "lodash";
import ViewModel from "viewModels/ViewModel";
import RecordingRestoreDetailsView from "viewModels/RecordingRestoreDetailsView";

const EmailRecordingView = ViewModel.extend(function (
    recordingModels,
    conversationObservable,
    conversationOriginatingDirection
) {
    const self = this;

    // <!-- check screen recording
    const readOnlyObservableFalse = self.computed(function () {
        return false;
    });
    self.hasScreenRecording = readOnlyObservableFalse;
    self.isDeleted = readOnlyObservableFalse;
    // --> end

    self.displayed = ko.observable(false);
    self.hasEmail = ko.observable(true);

    self.conversation = ko.isObservable(conversationObservable)
        ? conversationObservable
        : ko.observable(conversationObservable);

    // map all recordingModels to observable
    const observableRecordingModels = _.map(
        _.filter(recordingModels, { media: "email" }),
        ko.observable
    );

    self.recordingRestoreDetails = self.subView(
        RecordingRestoreDetailsView,
        observableRecordingModels.length > 0
            ? observableRecordingModels[0]
            : readOnlyObservableFalse,
        {
            isEmailContainer: ko.observable(true),
        },
        self.conversation,
        conversationOriginatingDirection
    );

    self.recording = self.computed(() =>
        self.recordingRestoreDetails.recording()
    );
});

export default EmailRecordingView;
